module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "timeline"
  }, [_vm._l((_vm.history), function(testimony, index) {
    return [_c('li', {
      staticClass: "time-label"
    }, [(testimony.updatedAt && (index === 0 || !_vm.sameDate(testimony.updatedAt, _vm.history[index - 1].updatedAt))) ? _c('span', {
      staticClass: "bg-orange"
    }, [_vm._v("\n              " + _vm._s(_vm._f("prettyDate")(testimony.updatedAt)) + "\n            ")]) : _vm._e(), _vm._v(" "), (!testimony.updatedAt) ? _c('span', {
      staticClass: "bg-orange"
    }, [_vm._v("\n              " + _vm._s(_vm._f("prettyDate")(testimony.creationDate)) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('i', {
      staticClass: "fa fa-envelope bg-red"
    }), _vm._v(" "), _c('div', {
      staticClass: "timeline-item"
    }, [(testimony.updatedAt) ? _c('span', {
      staticClass: "time"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" " + _vm._s(_vm._f("prettyTime")(testimony.updatedAt)))]) : _vm._e(), _vm._v(" "), (!testimony.updatedAt) ? _c('span', {
      staticClass: "time"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" " + _vm._s(_vm._f("prettyTime")(testimony.creationDate)))]) : _vm._e(), _vm._v(" "), (!testimony.updatedAt && testimony.victimIdentity) ? _c('h3', {
      staticClass: "timeline-header"
    }, [_c('strong', [_vm._v(_vm._s(testimony.purpose !== 'VICTIM' ? (testimony.witnessIdentity.name ? testimony.witnessIdentity.name : 'An anonymous person') : (testimony.victimIdentity.name ? testimony.victimIdentity.name : 'An anonymous person')))]), _vm._v(" has created the testimony as a " + _vm._s(testimony.purpose) + "\n          ")]) : _vm._e(), _vm._v(" "), (testimony.updatedAt && testimony.updatedBy) ? _c('h3', {
      staticClass: "timeline-header"
    }, [_c('strong', [_vm._v(_vm._s(testimony.updatedBy.firstName + ' ' + testimony.updatedBy.lastName) + " (" + _vm._s(testimony.updatedBy.role) + ")")]), _vm._v(" has updated the testimony\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "timeline-body"
    }, [_vm._l((_vm.customizeDiff(_vm.history[index], _vm.history[index + 1])), function(message) {
      return [_c('span', {
        domProps: {
          "innerHTML": _vm._s(message)
        }
      })]
    })], 2)])])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c271ef1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Timeline.vue
// module id = 443
// module chunks = 1